// extracted by mini-css-extract-plugin
export default {"intoFormContainer":"NameForm_intoFormContainer__LEx-J","modal-footer":"NameForm_modal-footer__hdYix","modal-cancel-button":"NameForm_modal-cancel-button__O-tDY"};